import React, { Fragment } from "react";
import DropdownItem from "reactstrap/lib/DropdownItem";
import RSDropdownMenu from "reactstrap/lib/DropdownMenu";
import { gatherConditionalProps, isFunction, hasProperty } from "./utils";

export const dropdownHasSubmenus = items =>
  (items || []).some(
    item =>
      (!item.heading && hasProperty(item, "items")) ||
      (item.heading && (item.items || []).some(i => hasProperty(i, "items")))
  );

export const markDropdownItemsAsParent = (items = []) => {
  return items.map(item => {
    if (!item.heading && hasProperty(item, "items")) {
      item.isParent = true;
    } else if (item.heading && item.items) {
      item.items = markDropdownItemsAsParent(item.items);
    }
    return item;
  });
};

export const getMaxHeight = props => {
  return String(props.maxMenuHeight).endsWith("px")
    ? props.maxMenuHeight
    : `${props.maxMenuHeight}px`;
};

export default class DropdownUtils {
  constructor(hasSubmenus) {
    this.hasSubmenus = hasSubmenus;
  }

  renderDropdownItems = props => {
    const itemsWithParent = markDropdownItemsAsParent(props.items);

    return itemsWithParent.map((item, index) => {
      if (hasProperty(item, "divider")) {
        return this.renderDivider(index);
      }

      if (hasProperty(item, "heading")) {
        return this.renderHeadingItems(props, item, index);
      }

      return this.renderItem(props, item, index);
    });
  };

  renderDivider = index => <DropdownItem divider key={index} />;

  renderItem = (props, item, index) => {
    const { href, target } = item;
    const linkProps = {};
    if (href) {
      linkProps.href = href;
      if (target) {
        linkProps.target = target;
      }
    }

    return isFunction(item.renderComponent) ? (
      item.renderComponent(item, index, null, "oui-dropdown-item")
    ) : (
      <DropdownItem
        tag={item.isParent ? "li" : "button"}
        key={index}
        {...gatherConditionalProps(item, "disabled", "onClick")}
        active={item.isActive}
        {...linkProps}
        onClick={
          !item.isParent
            ? e => {
                if (isFunction(props.onItemClick)) {
                  props.onItemClick(item, e);
                }
              }
            : null
        }
        className={item.isParent ? "oui-dropdown-item-parent" : ""}
      >
        {isFunction(item.label) ? item.label(item) : item.label}
        {item.isParent ? (
          <RSDropdownMenu
            className="oui-dropdown-submenu"
            tag="ul"
            style={
              !dropdownHasSubmenus(item.items)
                ? { maxHeight: getMaxHeight(props), overflowY: "auto" }
                : { overflow: "visible", maxHeight: "none" }
            }
          >
            {this.renderDropdownItems({ ...props, items: item.items })}
          </RSDropdownMenu>
        ) : null}
      </DropdownItem>
    );
  };

  renderHeadingItems = (props, headingItem, index) => {
    return (
      <Fragment key={`fg-${index}`}>
        <DropdownItem header key={`header-${index}`}>
          {headingItem.heading}
        </DropdownItem>
        {headingItem.items.map((item, ind) => {
          return this.renderItem(props, item, `header-${index}-${ind}`);
        })}
      </Fragment>
    );
  };
}
